// extracted by mini-css-extract-plugin
export default {"container":"Removed_container__lk1Tp","list":"Removed_list__BQTOG","actions":"Removed_actions__Riiaa"};